<template>
  <div class="sidebar resizable-menu" id="sidebarId" :style="{width: menuWidth + 'px'}">
    <el-collapse v-model="activeApp" accordion @change="collapseApp(activeApp,false)">
      <el-collapse-item :key="item.app_code" v-for="item in appList" :name="item.app_code" >
        <template slot="title">
          <i :class="item.app_icon"></i><span v-show="!collapse">{{item.app_sort}}</span>
        </template>
        <div>
          <el-menu :default-active="currMenu" :collapse="collapse" @select="activeMenu" >
            <menu-tree :menuData="menuListObj[item.app_code]"></menu-tree>
          </el-menu>
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="resize-handle" @mousedown="startResize"></div>
  </div>
</template>

<script>
import MenuTree from '../base/MenuTree.vue'
import menuUtils from '@/assets/js/menuUtils.js'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import VueRouter from 'vue-router'

export default {
  data () {
    return {
      isResizing: false,
      startX: 0,
      startWidth: 0,
      activeApp: '',
      collapse: false,
      appList: [],
      menuList: [],
      menuListObj: {},
      asyncRouters: []
    }
  },
  components: {
    MenuTree
  },
  methods: {
    ...mapActions('dynamicRouter', ['addMenuRouters']),
    ...mapGetters('dynamicRouter', ['getMenuLists']),
    ...mapMutations('cacheTabs', ['setKeepAliveList']),
    ...mapMutations('dynamicRouter', ['setMenuLists']),
    ...mapMutations('pageHeight', ['setMenuWidth']),
    startResize (event) {
      this.isResizing = true
      this.startX = event.clientX
      this.startWidth = this.menuWidth
      document.addEventListener('mousemove', this.doResize)
      document.addEventListener('mouseup', this.stopResize)
    },
    doResize (event) {
      if (this.isResizing) {
        const diffX = event.clientX - this.startX
        let mWidth = Math.max(200, this.startWidth + diffX) // 限制最小宽度为100px
        if (mWidth > 450) {
          mWidth = 450
        }
        const that = this
        that.setMenuWidth(mWidth)
      }
    },
    stopResize () {
      document.removeEventListener('mousemove', this.doResize)
      document.removeEventListener('mouseup', this.stopResize)
      this.isResizing = false
    },
    loadUserAppList: async function () {
      const lang = localStorage.getItem('lang')
      const { data: res } = await this.$http.post('/users/getUserAppList', { lang })
      if (res.data) {
        this.appList = res.data
        // const lang = localStorage.getItem('lang')
        const site = window.sessionStorage.getItem('currentSite')
        this.menuList = []
        for (const i in this.appList) {
          const para = {
            site: site,
            app: this.appList[i].app_code,
            lang: lang,
            par: ''
          }
          const { data: res } = await this.$http.post('/users/getUserMn', para)
          this.menuListObj[this.appList[i].app_code] = res.data
          // this.menuList = Object.assign(this.menuList, res.data)
          this.menuList = this.menuList.concat(res.data)
        }
        this.menuList.push({
          r_mn_id: this.userHomePage,
          r_mn_link: '/' + this.userHomePage,
          r_mn_path: 'components/main/' + this.userHomePage,
          r_vue_name: this.userHomePage,
          r_keep_live: true
        })
        /**
        const { data: res2 } = await this.$http.post('/users/getListStaticRouterAll', {})
        if (res2.data) {
          const staticList = res2.data
          for (const j in staticList) {
            this.menuList.push({
              r_mn_id: staticList[j].staticCode,
              r_mn_link: staticList[j].staticLink,
              r_mn_path: staticList[j].staticPath,
              r_mn_desc: staticList[j].staticName,
              r_mn_para: '',
              r_keep_live: staticList[j].staticKeepLive,
              r_vue_name: staticList[j].staticVueName
            })
          }
        }
        **/
        this.setMenuLists(this.menuList)
        const children = menuUtils.getRouters(this.menuList)
        // const result = []
        this.$router.options.routes[2].children = children
        // result.push(this.$router.options.routes[2])
        this.$router.matcher = new VueRouter().matcher
        this.$router.$addRoutes(this.$router.options.routes)
        // this.$router.addRoutes(this.$router.options.routes)
        // result.push({
        //   path: '/main',
        //   name: 'Main',
        //   component: Main,
        //   children: children,
        //   meta: {
        //     title: i18n.t('users.login.title')
        //   }
        // })
        // window.sessionStorage.setItem('dyanmicRouters', JSON.stringify(res.data))
        // this.addMenuRouters(result)

        const defApp = window.sessionStorage.getItem('defApp')
        this.activeApp = defApp
      }
    },
    collapseApp: async function (activeApp, flag) {
      const currentApp = window.sessionStorage.getItem('defApp')
      if (((currentApp === activeApp) && (!flag)) || (activeApp === '')) return
      window.sessionStorage.setItem('defApp', activeApp)
    },
    setUserDefApp: function () {
      const defApp = window.sessionStorage.getItem('defApp')
      // this.collapseApp(defApp, true)
      this.activeApp = defApp
    },
    activeMenu: function (index, indexPath) {
      /** const dot = index.indexOf('?')
      const name = index.substring(0, dot)
       **/
      const menuLists = this.getMenuLists()
      const menuObj = menuUtils.getMenuLists(menuLists, index)
      const paraStr = menuObj.r_mn_para
      let para = {}
      if ((paraStr) && (paraStr !== '')) {
        para = JSON.parse(paraStr)
      }
      para.id = index
      this.$router.push({
        name: index,
        params: para
        // eslint-disable-next-line handle-callback-err
      }).catch(err => {})
      this.mnClickLog(para)
    },
    mnClickLog: async function (para) {
      const that = this
      para.user = that.$Any.getCurrentUser()
      await this.$http.post('/users/postMnLogMstr', para)
    }
  },
  computed: {
    ...mapGetters('cacheTabs', ['userHomePage']),
    ...mapState('pageHeight', ['menuWidth']),
    currMenu () { // 当前激活的导航
      return this.$route.params.id
    }
  },
  created () {
    this.loadUserAppList()
  },
  mounted () {
    // this.setUserDefApp()
    document.addEventListener('click', e => {
      const that = this
      const className = e.target.className
      const classMap = ['header-img', 'el-icon-s-fold', 'el-icon-s-unfold']
      if (classMap.includes(className)) {
        that.collapse = !that.collapse
      }
    })
  }
}
</script>

<style>
  .resizable-menu {
    position: relative;
    background-color: #f0f0f0;
    border: 1px solid #ccc;
    cursor: col-resize;
  }
  .menu-content {
    padding: 10px;
  }
  .resize-handle {
    position: absolute;
    right: 0;
    top: 0;
    width: 5px; /* 可视化的调整把手宽度 */
    height: 100%;
    cursor: col-resize;
  }
  .el-menu--collapse .el-submenu__title span{
    display: none;
  }
  .el-menu--collapse .el-submenu__title .el-submenu__icon-arrow{
    display: none;
  }
  .sidebar {
    display: block;
    position: absolute;
    left: 0;
    top: 40px;
    bottom: 0;
    overflow-y: auto;
    background-image: linear-gradient(to right, #55abff, #FFFFFF);
    background-color: rgba(0,0,0,0.2);
    white-space:nowrap;
  }
  .sidebar::-webkit-scrollbar {

  }
  .el-menu--popup-right-start {
    margin-left: -20px!important;
  }
</style>
